(function () {
  const CAMPAIGN = {
    code: 'FeniksEnergy0630',
    productId: 15517830381908,
    fallbackVariantId: 56339808387412,
    fallbackProductPath: '/products/marstek-venus-e-3-0-plug-play-thuisbatterij',
    successTitle: 'Korting geclaimd',
    successMessage: 'Je korting is succesvol geclaimd. De korting wordt automatisch berekend bij het afrekenen.'
  };

  let productClaiming = false;

  function isCampaignLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return false;

    try {
      const url = new URL(link.href, window.location.origin);
      return url.pathname.toLowerCase().includes(`/discount/${CAMPAIGN.code.toLowerCase()}`);
    }
    catch (error) {
      return link.href.includes(CAMPAIGN.code);
    }
  }

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function cartJsonUrl() {
    return `${theme.routes.cart_url}.js`;
  }

  async function getCart() {
    const response = await fetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Unable to load cart.');
    return response.json();
  }

  function mainProductInfo() {
    return document.querySelector('main product-info[data-product-id][form]')
      || document.querySelector('product-info[data-product-id][form]');
  }

  function selectedVariantId(info) {
    const formId = info ? info.getAttribute('form') : '';
    const form = formId ? document.getElementById(formId) : null;
    const input = form ? form.querySelector('[name="id"]:not([disabled])') : null;
    const id = input ? Number(input.value) : 0;

    return Number.isFinite(id) && id > 0 ? id : CAMPAIGN.fallbackVariantId;
  }

  function currentProductTarget() {
    const info = mainProductInfo();
    const productId = info ? Number(info.dataset.productId) : 0;

    return {
      productId: Number.isFinite(productId) && productId > 0 ? productId : CAMPAIGN.productId,
      variantId: selectedVariantId(info)
    };
  }

  function cartHasCampaignProduct(cart, target) {
    return cart.items.some((item) => Number(item.product_id) === target.productId);
  }

  function bundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));
    return sections;
  }

  async function addCampaignProductIfNeeded(cart, target) {
    if (cartHasCampaignProduct(cart, target)) return { cart, added: false };

    const sections = bundledSections();
    const response = await fetch(theme.routes.cart_add_url, {
      ...theme.utils.fetchConfig('javascript'),
      body: JSON.stringify({
        items: [{ id: target.variantId, quantity: 1 }],
        sections,
        sections_url: window.location.pathname
      })
    });
    const parsedState = await response.json();

    if (!response.ok || parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || 'Unable to add product.');
    }

    const updatedCart = await getCart();
    if (parsedState.sections) updatedCart.sections = parsedState.sections;

    return { cart: updatedCart, added: true };
  }

  async function applyDiscountCode(redirectPath) {
    const discountUrl = new URL(`/discount/${CAMPAIGN.code}`, window.location.origin);
    discountUrl.searchParams.set('redirect', redirectPath || theme.routes.cart_url);

    await fetch(discountUrl.toString(), {
      credentials: 'same-origin',
      redirect: 'follow'
    });
  }

  function publishCart(cart) {
    if (!cart || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS) return;

    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'feniks-discount-claim',
      cart
    });
  }

  function openCartDrawer(cart) {
    publishCart(cart);

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    }));
  }

  function ensureToastStyles() {
    if (document.getElementById('FeniksDiscountClaimStyles')) return;

    const style = document.createElement('style');
    style.id = 'FeniksDiscountClaimStyles';
    style.textContent = `
      .feniks-discount-toast {
        position: fixed;
        bottom: clamp(18px, 5vw, 42px);
        left: 50%;
        z-index: 90;
        display: grid;
        gap: 8px;
        width: min(560px, calc(100vw - 32px));
        padding: 22px 26px;
        color: #fff;
        background: #009CEA;
        border-radius: 22px;
        box-shadow: 0 18px 50px rgb(0 0 0 / 0.18);
        opacity: 0;
        transform: translate(-50%, 14px);
        pointer-events: none;
        transition: opacity var(--animation-fast), transform var(--animation-fast);
      }

      .feniks-discount-toast.is-visible {
        opacity: 1;
        transform: translate(-50%, 0);
      }

      .feniks-discount-toast__title {
        font-family: var(--font-heading-family);
        font-size: var(--text-base);
        font-weight: 700;
        line-height: 1.1;
      }

      .feniks-discount-toast__message {
        font-size: var(--text-sm);
        line-height: 1.35;
      }

      @media screen and (max-width: 639px) {
        .feniks-discount-toast {
          width: calc(100vw - 32px);
          border-radius: 22px;
        }
      }

      .feniks-cart-claim-loading {
        position: absolute;
        inset: 0;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgb(var(--color-background) / 0.72);
        backdrop-filter: blur(10px);
        pointer-events: auto;
      }

      .feniks-cart-claim-loading__spinner {
        width: 52px;
        height: 52px;
        border: 4px solid rgb(var(--color-foreground) / 0.12);
        border-top-color: #009CEA;
        border-radius: 999px;
        animation: feniks-cart-claim-spin 0.8s linear infinite;
      }

      @keyframes feniks-cart-claim-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    document.head.appendChild(style);
  }

  function showDiscountToast() {
    ensureToastStyles();

    const previous = document.querySelector('.feniks-discount-toast');
    if (previous) previous.remove();

    const toast = document.createElement('div');
    toast.className = 'feniks-discount-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `
      <div class="feniks-discount-toast__title">${CAMPAIGN.successTitle}</div>
      <div class="feniks-discount-toast__message">${CAMPAIGN.successMessage}</div>
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('is-visible'));
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 350);
    }, 3800);
  }

  function showCartLoading() {
    ensureToastStyles();

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const previous = drawer.querySelector('.feniks-cart-claim-loading');
    if (previous) previous.remove();

    const loading = document.createElement('div');
    loading.className = 'feniks-cart-claim-loading';
    loading.setAttribute('role', 'status');
    loading.setAttribute('aria-live', 'polite');
    loading.setAttribute('aria-label', 'Product wordt toegevoegd');
    loading.innerHTML = '<span class="feniks-cart-claim-loading__spinner" aria-hidden="true"></span>';
    drawer.appendChild(loading);
  }

  function hideCartLoading(delay = 250) {
    const drawer = document.querySelector('cart-drawer');
    const loading = drawer ? drawer.querySelector('.feniks-cart-claim-loading') : null;
    if (!loading) return;

    setTimeout(() => loading.remove(), delay);
  }

  async function claimFromHome(link) {
    link.setAttribute('aria-busy', 'true');
    showDiscountToast();

    try {
      await applyDiscountCode(CAMPAIGN.fallbackProductPath);
    }
    catch (error) {
      console.error(error);
    }
    finally {
      link.removeAttribute('aria-busy');
    }
  }

  async function claimFromProduct(link) {
    if (productClaiming) return;
    productClaiming = true;
    link.setAttribute('aria-busy', 'true');
    const target = currentProductTarget();

    try {
      openCartDrawer();
      showCartLoading();

      const cart = await getCart();
      const result = await addCampaignProductIfNeeded(cart, target);
      openCartDrawer(result.cart);
      hideCartLoading(450);

      applyDiscountCode(theme.routes.cart_url)
        .then(() => getCart())
        .then((discountedCart) => {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true }
          }));
          publishCart(discountedCart);
        })
        .catch((error) => console.error(error));
    }
    catch (error) {
      hideCartLoading(0);
      console.error(error);
      window.location.href = link.href;
    }
    finally {
      productClaiming = false;
      link.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;

    if (!isCampaignLink(link)) return;

    event.preventDefault();
    event.stopPropagation();

    if (isProductPage()) {
      claimFromProduct(link);
    }
    else {
      claimFromHome(link);
    }
  }, true);
})();
